export default "__VITE_ASSET__gA56TDxf__"